import { Grid, Typography, Button, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { WarehouseDDL } from '../../../components/Almacen'
import { useApi } from '../../../hooks/useApi'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { Status } from '../../../hooks/useFetchState'
import SaveIcon from '@mui/icons-material/Save'

interface ChangeWorkOrderWarehouseComponentProps {
  workOrderId: number
  actualWarehouseId: number
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const patchWorkOrderWarehouse = (
  workOrderId: number,
  warehouseId: number
) => {
  const url = new URL(`${ApiConfig.WorkOrderApi}?workOrderId=${workOrderId}`)

  return axios.patch(url.toString(), { warehouseId })
}

export const ChangeWorkOrderWarehouseComponent: React.FC<ChangeWorkOrderWarehouseComponentProps> =
  ({ workOrderId, actualWarehouseId, openSnackBar }) => {
    const [selectedWarehouse, setSelectedWarehouse] = useState<
      number | undefined
    >(actualWarehouseId)

    const { state, callApi } = useApi()

    const requestReassignWorkOrderCallApi = () => {
      if (selectedWarehouse) {
        callApi(patchWorkOrderWarehouse(workOrderId, selectedWarehouse))
          .then(() =>
            openSnackBar(
              'OT ha sido correctamente asignada al nuevo almacén',
              true
            )
          )
          .catch((err) => openSnackBar(err, false))
      }
    }

    const isLoading = state.status === Status.Loading

    return (
      <Grid container direction='row' item xs={12} spacing={3}>
        <Grid item xs={12} sm={4}>
          <Typography>Reasignar almacén</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <WarehouseDDL
            fullWidth
            type='outlined'
            onChange={(
              event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
            ) => setSelectedWarehouse(parseInt(event.target.value))}
            value={selectedWarehouse}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            disabled={
              isLoading ||
              selectedWarehouse === actualWarehouseId ||
              selectedWarehouse === -1
            }
            variant='contained'
            color='primary'
            onClick={requestReassignWorkOrderCallApi}
            endIcon={
              isLoading ? <CircularProgress size={'14px'} /> : <SaveIcon />
            }
          />
        </Grid>
      </Grid>
    )
  }
